const verifyToken = async () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-type", "application/json");
    myHeaders.append("Authorization", window.localStorage.token);
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
    //   body: raw,
      redirect: 'follow'
    };
    
    return fetch(`${process.env.REACT_APP_API_URL}/verify_token`, requestOptions)
      .then(response => response.status)
      .catch(error => {throw new Error(error)});
}

export default verifyToken